module.exports = __webpack_public_path__ + "img/moon-stars.c26abfbf.svg";